import { directDownload } from '@/utils/download-helper';
import Axios from 'axios';
import { ActionTree } from 'vuex';
import { RootState } from '../../types';
import { PreprocessingRuleItem, PreprocessingRulesState, PreprocessingRuleFilter } from './types';
import axios from "axios";

export const actions: ActionTree<PreprocessingRulesState, RootState> = {
  getPreprocessingRules: ({ commit }, data) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({ url: '/acapi/additional_processing_rules', params: data })
        .then(resp => {
          commit('setPreprocessingRules', resp.data.additional_processing_rules);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  getPreprocessingRuleItem: ({ commit }, id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({ url: `/acapi/additional_processing_rules/${id}` })
        .then((resp: any) => {
          let preprocessingRuleItem = <PreprocessingRuleItem>resp.data;
          preprocessingRuleItem.id = id;
          commit('setPreprocessingRuleItem', preprocessingRuleItem);
          resolve(preprocessingRuleItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  savePreprocessingRuleItem: ({ commit, dispatch }, data: PreprocessingRuleItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/additional_processing_rules/' + (data.id ?? ''),
        data: data
      })
        .then((resp: any) => {
          dispatch('getPreprocessingRules');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  savePreprocessingPriority: ({commit, dispatch}, data:any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/acapi/additional_processing_rules/priority',
        data: data
      })
          .then((resp: any) => {
            resolve(resp)
          })
          .catch((err: any) => {
            reject(err)
          })
          .finally(() => commit('setLoading', false));
    })
  },
  deletePreprocessingRuleItem: ({ commit, dispatch }, data: PreprocessingRuleItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({
        method: 'delete',
        url: `/acapi/additional_processing_rules/${data.id}`,
        data: data
      })
        .then((resp: any) => {
          dispatch('getPreprocessingRules');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  exportPreprocessingRules: ({ }, data: PreprocessingRuleFilter) => {
    return directDownload('/acapi/additional_processing_rules/export', data)
  }
};
